let module = angular.module('app.resources');

// XXX: Let the reader beware! I tried doing this with an interceptor on the resource below, but
// Angular 1.whatever does some _shenanigans_ with resource interceptors, and no matter what I
// tried, I could not get this to work that way. So this http interceptor looks for 404 responses
// on the current account reseller route and resolves them with an empty object.
module.config(($httpProvider) => {
  'ngInject';
  $httpProvider.interceptors.push(($q) => {
    return {
      responseError: (rejection) => {
        if ((rejection.config || {}).url == `${API_ROOT}/account/reseller`) {
          rejection.status = 200;
          rejection.data = {};
          return $q.resolve(rejection);
        }
        return $q.reject(rejection);
      },
    };
  });
});

module.factory('AccountReseller', ($resource) => {
  'ngInject';
  return $resource(`${API_ROOT}/account/reseller`);
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/account_reseller.js